"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var useConfigurableStyle_1 = require("../_utils/useConfigurableStyle");
var loading_1 = require("../loading");
var Search = function (_a) {
    var className = _a.className, overrideDefaultClassName = _a.overrideDefaultClassName, marginType = _a.marginType, fontColor = _a.fontColor, borderColor = _a.borderColor, children = _a.children, placeholder = _a.placeholder, searchText = _a.searchText, onTextChange = _a.onTextChange, isLoading = _a.isLoading, showResults = _a.showResults, props = __rest(_a, ["className", "overrideDefaultClassName", "marginType", "fontColor", "borderColor", "children", "placeholder", "searchText", "onTextChange", "isLoading", "showResults"]);
    var _b = useConfigurableStyle_1.useConfigurableStyle({
        defaultClassName: "search",
        additionalClassName: className,
        overrideDefaultClassName: overrideDefaultClassName,
        marginType: marginType,
        fontColor: fontColor,
        borderColor: borderColor,
        styleProp: props.style
    }), finalClassName = _b[0], style = _b[1];
    return (react_1.default.createElement("div", __assign({ className: finalClassName }, props, { style: style }),
        react_1.default.createElement("div", { className: "search__icon" }, isLoading ? (react_1.default.createElement(loading_1.LoadingRing, { seafoam: true })) : (react_1.default.createElement("i", { className: "far fa-search" }))),
        react_1.default.createElement("input", { type: "search", placeholder: placeholder || "Search", className: "search__input", value: searchText, onChange: typeof onTextChange === "function" ? function (e) { var _a; onTextChange(((_a = e === null || e === void 0 ? void 0 : e.target) === null || _a === void 0 ? void 0 : _a.value) || ""); } : function () { } }),
        react_1.default.createElement("ul", { className: "search__result-list", style: (showResults && !!children) ? {} : { display: "none" } }, children)));
};
exports.default = Search;
